import axios from '@/libs/api.request'

export const PutStaff = data => {
  return axios.request({
    url: '/company/staff',
    data,
    method: 'put'
  })
}
export const GetStaff = data => {
  return axios.request({
    url: '/company/staff',
    params: data,
    method: 'get'
  })
}
export const CheckStaffTel = data => {
  return axios.request({
    url: '/company/staff/tel/check',
    params: data,
    method: 'get'
  })
}
export const StaffRecharge = data => {
  return axios.request({
    url: '/company/staff/recharge',
    data,
    method: 'put'
  })
}
export const BatchStaff = data => {
  return axios.request({
    url: '/company/staff/batch',
    data,
    method: 'put'
  })
}
export const BatchStaffPWD = data => {
  return axios.request({
    url: '/company/staff/batch/pwd',
    data,
    method: 'put'
  })
}


export const GetStaffRechargeList = data => {
  return axios.request({
    url: '/company/staff/recharge_list',
    params: data,
    method: 'get'
  })
}

export const StaffRechargeData = data =>{
  return axios.request({
    url: '/company/staff/staff_recharge',
    data,
    method: 'put'
  })
}
export const BatchStaffInsert = data => {
  return axios.request({
    url: '/company/staff/batch/insert',
    data,
    method: 'put'
  })
}
